import {Alert, Backdrop, CircularProgress, Container, Grid, Paper, styled} from "@mui/material";
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {getAllBatches} from "../features/allBatchesSlice";
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import Typography from "@mui/material/Typography";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";
import ShowSnackbar from "../utils/ShowSnackbar";
import OrgTypePagePasteURLPanel from "./OrgTypePagePasteURLPanel";

/**
 * @date: 04/29/23
 * @author: Kengcheng Feng <kfeng@max.md>
 * @copy: (C) Copyright 2023 MaxMD Corporation, All Rights Reserved.
 */


const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),

}))
const StyledPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    overflow: 'auto',
    boxShadow: '0 7px 20px #cccccc',
    minHeight: '200px'
}))

export default function OrgTypeNewImportTask(props) {
    const location = useLocation();
    const path = location.pathname;
    const dispatch = useDispatch();


    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({ open: false, msg: '', msgLv: ''});

    const { orgTypeBatches, batchRefresh } = useSelector(state => state.allBatches);


    useEffect(() => {
        // getActiveBatchProgress("ImportValueSet", setLoading, setSnackbarMsg)
        //     .then( res => {
        //         res && dispatch(addorgTypeBatch(res));
        //     })
        dispatch(getAllBatches());
    }, [batchRefresh])

    return (
        <StyledContainer>
            <ExternalSourceBreadcrumbs path={path} />
            <h3 className='title'>
                New Organization Type Import Task
            </h3>
            <Grid item xs={12} md={12} lg={12}>
                <h4>Organization Type ValueSet URL</h4>
                <StyledPaper sx={{minHeight: '120px'}}>
                    <Typography gutterBottom>
                        Please enter the URL:
                    </Typography>
                    <OrgTypePagePasteURLPanel/>
                </StyledPaper>
            </Grid>
            <br/>
            <br/>
            <Grid item xs={12} md={12} lg={12}>
                <h4>Organization Type Import Progress</h4>
                <StyledPaper>
                    { orgTypeBatches.length > 0 && orgTypeBatches[0].status !== 'Init' &&
                        <Alert severity={batchCurrentStatus[orgTypeBatches[0].status].getStatus} icon={false}>{batchCurrentStatus[orgTypeBatches[0].status].getMsg("orgType")}</Alert>}
                    { orgTypeBatches.length > 0 && orgTypeBatches[0].status !== 'Completed' && orgTypeBatches[0].status !== 'Cancelled' && orgTypeBatches[0].status !== 'Failed' &&
                        <ExternalSourceBatchProgressBar batch={orgTypeBatches[0]}/> }
                </StyledPaper>
            </Grid>
            {snackbarMsg.msg && snackbarMsg.msgLv &&
                <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            }

            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={ loading }>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}

